import { render } from "./profileData.vue?vue&type=template&id=a82dcbb2&scoped=true"
import script from "./profileData.vue?vue&type=script&lang=js"
export * from "./profileData.vue?vue&type=script&lang=js"

import "./profileData.vue?vue&type=style&index=0&id=a82dcbb2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82dcbb2"]])

export default __exports__